/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Badge_SoldInputs */

const en_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sold`)
};

const es_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const fr_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendu`)
};

const de_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verkauft`)
};

const ja_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`売却済み`)
};

const zh_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已售`)
};

const ar_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مباع`)
};

const id_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terjual`)
};

const it_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venduto`)
};

const ru_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Продано`)
};

const pt_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vendido`)
};

const ko_badge_sold = /** @type {(inputs: Badge_SoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`품절`)
};

/**
* | output |
* | --- |
* | "Sold" |
*
* @param {Badge_SoldInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const badge_sold = /** @type {((inputs?: Badge_SoldInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Badge_SoldInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_badge_sold(inputs)
	if (locale === "es") return es_badge_sold(inputs)
	if (locale === "fr") return fr_badge_sold(inputs)
	if (locale === "de") return de_badge_sold(inputs)
	if (locale === "ja") return ja_badge_sold(inputs)
	if (locale === "zh") return zh_badge_sold(inputs)
	if (locale === "ar") return ar_badge_sold(inputs)
	if (locale === "id") return id_badge_sold(inputs)
	if (locale === "it") return it_badge_sold(inputs)
	if (locale === "ru") return ru_badge_sold(inputs)
	if (locale === "pt") return pt_badge_sold(inputs)
	return ko_badge_sold(inputs)
});